import api from "@/services/api/exercise/api-exams"
import ExamModel from "./models/examModel"

export default class ExamService {
  constructor(authSvc) {
    this.authSvc = authSvc
  }

  async list(query) {
    try {
      let res = await api.list(query)
      if(!res.results) throw new Error('Something went wrong and chapters are not loading. Please, reload page or try again later.')
      let data = {
        results: res.results.map( item => new ExamModel(item)),
        pagination: {
          count: res.count,
          next: res.next,
          previous: res.previous
        }
      }
      return data
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async get(id) {
    try {
      let res = await api.get(id)
      if(!res) throw new Error('Something went wrong and chapter are not loading. Please, reload page or try again later.')
      return new ExamModel(res)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async create(model) {
    try {
      let res = await api.create(model.getApiData())
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async put(id, model) {
    try {
      let res = await api.put(id, model.getApiData())
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async remove(id) {
    try {
      let res = await api.remove(id)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

}
